import { useCallback } from 'react';
import type {
  ReactElement,
  ReactNode,
} from 'react';

import {
  StyledLabel,
  StyledCircle,
  StyledInput,
  StyledContent,
} from './styled';

export type RadioValue = string | number;

export type RadioProps = {
  /**
   * value html-элемента input, также передаётся в колбэке onChange
   */
  value: RadioValue;
  /**
   * выбрано
   */
  checked: boolean;
  /**
   * выключено
   */
  disabled?: boolean;
  /**
  * name html-элемента input
  */
  name?: string;

  /**
   * текст/контент, выводящийся рядом с радио
   */
  label?: ReactNode;

  /**
   * хэндлер изменения значения, вызывается с параметрами: (newChecked)
   */
  onChange?: (value: RadioValue) => void;
};

export function Radio({
  value,
  checked,
  disabled = false,
  name = '',
  label = undefined,
  onChange = undefined,
}: RadioProps): ReactElement {
  const onInputChange = useCallback(() => {
    if (onChange) {
      onChange(value);
    }
  }, [
    value,
    onChange,
  ]);

  return (
    <StyledLabel
      $disabled={disabled}
      $hasLabel={Boolean(label)}
    >
      <StyledInput
        type="radio"
        value={value}
        checked={checked}
        disabled={disabled}
        name={name}
        onChange={onInputChange}
      />

      <StyledCircle
        $disabled={disabled}
        $checked={checked}
      />

      {
        label && (
          <StyledContent>
            {label}
          </StyledContent>
        )
      }
    </StyledLabel>
  );
}
